import DragModal from './DragModal.vue'

const obj = {}

obj.install = function(Vue){
  Vue.component('DragModal',DragModal);
}

export default obj;